import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HPInput from "@/components/common/Input";
import PrimaryColorPicker from "./PrimaryColorPicker";

interface StylingSectionProps {
  title: string;
  subtitle: string;
  metricColumnHeader: string;
  primaryBrandLabel: string | null;
  primaryBrandHighlightColor: string | null;
  onTitleChange: (value: string) => void;
  onSubtitleChange: (value: string) => void;
  onMetricColumnHeaderChange: (value: string) => void;
  onPrimaryBrandHighlightColorChange: (color: string | null) => void;
}

const StylingSection: React.FC<StylingSectionProps> = ({
  title,
  subtitle,
  metricColumnHeader,
  primaryBrandLabel,
  primaryBrandHighlightColor,
  onTitleChange,
  onSubtitleChange,
  onMetricColumnHeaderChange,
  onPrimaryBrandHighlightColorChange,
}) => {
  const theme = useTheme();

  return (
    <Accordion
      defaultExpanded
      sx={{ boxShadow: "none", border: "1px solid #eee" }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Styling & Customization
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <HPInput
            label="Chart title"
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
          />
          <HPInput
            label="Subtitle"
            value={subtitle}
            onChange={(e) => onSubtitleChange(e.target.value)}
            placeholder="Optional"
          />
          <Box>
            <HPInput
              label="Metric column header"
              value={metricColumnHeader}
              onChange={(e) => onMetricColumnHeaderChange(e.target.value)}
              placeholder="Metric"
            />
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
              Leave blank to use &quot;Metric&quot;.
            </Typography>
          </Box>

          <PrimaryColorPicker
            primaryBrandLabel={primaryBrandLabel}
            color={primaryBrandHighlightColor}
            defaultColor={theme.palette.primary.main}
            onChange={onPrimaryBrandHighlightColorChange}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default StylingSection;
